import {SecureService} from "@/services/superclasses/secure-service";
import {Business} from "@/interfaces/business";

const api = window.contextPath + '/rest/businesses';

export class BusinessSecureService extends SecureService {

    public loadByMember = async (type: Array<number>): Promise<Business[]> => {
        return this.data(await this.get<Business[]>(api + "/by-member",
            {
                params: {
                    type
                }
            }))
    }
}

export const businessSecureService = new BusinessSecureService()